import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function SpecialCharacters() {
    return (
        <React.Fragment>
            <p>
                {' '}
                When naming a file, some characters should be avoided as they are either reserved or have specific
                meanings in a particular operating system. Using these characters produces errors or unexpected results.
            </p>

            <h4>Windows</h4>
            <ul>
                <p>
                    <code className="language-text">&lt;</code>(less than)
                </p>
                <p>
                    <code className="language-text">&gt;</code>(greater than)
                </p>
                <p>
                    <code className="language-text">:</code>(colon)
                </p>
                <p>
                    <code className="language-text">"</code>(double quote)
                </p>
                <p>
                    <code className="language-text">/</code>(forward slash)
                </p>
                <p>
                    <code className="language-text">\</code>(backslash)
                </p>
                <p>
                    <code className="language-text">|</code>(vertical bar or pipe)
                </p>
                <p>
                    <code className="language-text">?</code>(question mark)
                </p>
                <p>
                    <code className="language-text">*</code>(asterisk)
                </p>
            </ul>

            <h4>Linux/macOS</h4>
            <ul>
                <p>
                    <code className="language-text">&lt;</code>(less than)
                </p>
                <p>
                    <code className="language-text">&gt;</code>(greater than)
                </p>
                <p>
                    <code className="language-text">:</code>(colon)
                </p>
                <p>
                    <code className="language-text">"</code>(double quote)
                </p>
                <p>
                    <code className="language-text">/</code>(forward slash)
                </p>
                <p>
                    <code className="language-text">\</code>(backslash)
                </p>
                <p>
                    <code className="language-text">|</code>(vertical bar or pipe)
                </p>
                <p>
                    <code className="language-text">?</code>(question mark)
                </p>
                <p>
                    <code className="language-text">`</code>(backtick)
                </p>
            </ul>
            <p>
                <strong>Note</strong>: Avoid trailing spaces in Linux/macOS filenames. Extra spaces are not
                automatically removed by the operating system, as they are in Windows.
            </p>
        </React.Fragment>
    );
}

SpecialCharacters.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SpecialCharacters);
